export default "__VITE_ASSET__BEU6lf91__"